export default __webpack_public_path__ + "95d72cc28d70ad2ec5fe26ac22ec5e33.png";